export default class Configs {
  static readonly package = require('../../../../package.json');

  static readonly pagination = {
    startPage: 1,
    defaultSize: 25,
    sizeOptions: [10, 25, 50, 100],
    listAll: -1
  };

  static readonly hq = {
    timezone: 'America/New_York',
    countryCode: 'US',
  };

  static readonly defaultDetailType = 'DET001';

  static readonly fileLimit = {
    limit: 5 * 1024 * 1024 // 5MB
  };

  static readonly format = {
    dateStr: 'YYYYMMDD',
    date: 'MM/DD/YYYY',
    dateMMDDYYYY: 'MM/DD/YYYY',
    dateDDMMYYYY: 'DD/MM/YYYY',
    dateYYYYMMDD: 'YYYY/MM/DD',
    dateMMDDYY: 'MM/DD/YY',
    dateMMYYYY: 'MM/YYYY',
    dateYYYY: 'YYYY',
    dateDay: 'DD',
    time: 'h:mm a',
    hour: 'hh',
    minute: 'mm',
    a: 'a',
    dateTime: 'MM/DD/YYYY h:mm a',
    dateTime2: 'MM-DD-YYYY h:mm a',
    zonedDate: 'YYYY-MM-DD',
    zonedDateTime: 'YYYY-MM-DD HH:mm:ss',
    serverLocalDate: 'YYYY-MM-DD',
    serverLocalTime: 'hh:mm:ss',
    serverLocalDateTime: 'YYYY-MM-DDTHH:mm:ssz',
    serverLocalDateTime2: 'YYYY-MM-DDTHH:mm:ss',
    serverISODateTime: 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
    pickerTime: 'h:mm a',
    initTime: '00:00:00'
  };

  static readonly timeSlot = {
    AM: {
      start: '08:00',
    },
    PM: {
      start: '12:00',
    },
    EV: {
      start: '16:00',
    },
    DY: {
      start: '08:00',
    },
  }

  static readonly badgeColor = {
    service: '#B96518',
    detail: '#48634B',
    reason: '#48634B',
    status: '#1289A4',
    product: '#1289A4',
    warranty: '#1289A4',
    cardStatus: '#\n' +
      '      1: \'#848484\',\n' +
      '      2: \'#848484\',\n' +
      '      3: \'#848484\',\n' +
      '      4: \'#848484\',FF0000',
    symptom: {},
    // User Customer Type
    agent: '#D67216',
    partner: '#D67216',
    dealer: '#DEB41F',
    customer: '#DEB41F',
    admin: '#7D3A95',
    rsm_admin: '#1289A4',
    customer_admin: '#2C76CA',
    // store: '#DEB41F',
    // User Status
    active: '#2C76CA',
    inactive: '#C7271F',
    null: '#ffffff',
    //Concealed Damage Status
    draft: '#9d9d9d',
    pending: '#9d9d9d',
    prepare: '#9d9d9d',
    not_submitted: '#9d9d9d',
    requested: '#9d9d9d',
    review: '#2C76CA',
    reject: '#C7271F',
    data: '#D67216',
    process: '#a6e35b',
    approve: '#5bad0c',
    approved: '#5bad0c',
    rejected: '#C7271F',
    error: '#C7271F',
    canceled: '#C7271F',
    partially_completed: '#97f837',
    complete: '#8f8484',
    processing: '#2C76CA',
    approved_exchange: '#2C76CA',
    hq: '#2C76CA',
    store: '#9f9fef',
    ra: '#8f8484',
    completed: '#5bad0c',
    resolved: '#28a745',
    in_progress: '#2C76CA',
    notified: '#a6e35b',
  }
}
